// 引入axios基本配置
import http from '@/api/fetch.js'

/**
 * 上传图片
 */
export const uploadImage = (params) => {
    return http({
        url: '/api/v1/file/upload/image',
        method: 'post',
        data: params
    })
}

/**
 * 上传PDF
 */
export const uploadPdf = (params) => {
    return http({
        url: '/api/v1/file/upload/pdf',
        method: 'post',
        data: params,
        timeout: 200000,
    })
}

/**
 * 商家
 * 商家列表（分页）
 */
export const queryMerchantList = (params) => {
    return http({
        url: '/api/v1/showcase/merchant/page',
        method: 'post',
        data: params
    })
}

/**
 * 商家
 * 商家列表（全部）
 */
export const searchMerchantList = (params) => {
    return http({
        url: '/api/v1/showcase/merchant/list',
        method: 'post',
        data: params
    })
}

/**
 * 商家
 * 获取PointsMe门店列表
 */
export const queryPointsMeShop = (params) => {
    return http({
        url: '/api/v1/award/depot/shop/list',
        method: 'post',
        data: params
    })
}

/**
 * 商家
 * 创建商家
 */
export const createMerchant = (params) => {
    return http({
        url: '/api/v1/showcase/merchant/create',
        method: 'post',
        data: params
    })
}

/**
 * 商家
 * 查询商家详情
 */
export const queryMerchantDetails = (id) => {
    return http({
        url: `/api/v1/showcase/merchant/detail?id=${id}`,
        method: 'get'
    })
}

/**
 * 商家
 * 修改商家
 */
export const updateMerchant = (params) => {
    return http({
        url: '/api/v1/showcase/merchant/update',
        method: 'post',
        data: params
    })
}

/**
 * 商家
 * 删除商家
 */
export const deleteMerchant = (id) => {
    return http({
        url: `/api/v1/showcase/merchant/delete?id=${id}`,
        method: 'post'
    })
}

/**
 * 商家
 * 查询商家门店
 */
export const queryMerchantShop = (params) => {
    return http({
        url: '/api/v1/showcase/shop/search',
        method: 'post',
        data: params
    })
}

/**
 * 商家
 * 同步广告册
 */
export const syncMerchantAdvert = (id) => {
    return http({
        url: `api/v1/showcase/merchant/spider?id=${id}`,
        method: 'get'
    })
}

/**
 * 商家
 * 商家品牌校验
 */
export const merchantBrandCheckBrand = (params) => {
    return http({
        url: '/api/v1/showcase/merchant/check',
        method: 'get',
        params
    })
}

/**
 * 商家
 * 商家模板下载
 */
export const merchantTempDownload = () => {
    return http({
        url: '/api/v1/showcase/merchant/template/download',
        method: 'get',
        responseType: 'blob'
    })
}

/**
 * 商家
 * 商家导入
 */
export const merchantImport = (params) => {
    return http({
        url: '/api/v1/showcase/merchant/import',
        method: 'post',
        data: params,
        timeout: 120000
    })
}

/**
 * 门店
 * 门店列表（分页）
 */
export const queryShopList = (params) => {
    return http({
        url: '/api/v1/showcase/shop/page',
        method: 'post',
        data: params
    })
}

/**
 * 门店
 * 创建门店
 */
export const createShop = (params) => {
    return http({
        url: '/api/v1/showcase/shop/create',
        method: 'post',
        data: params
    })
}

/**
 * 门店
 * 查询门店详情
 */
export const queryShopDetails = (id) => {
    return http({
        url: `/api/v1/showcase/shop/detail?id=${id}`,
        method: 'get'
    })
}

/**
 * 门店
 * 修改门店
 */
export const updateShop = (params) => {
    return http({
        url: '/api/v1/showcase/shop/update',
        method: 'post',
        data: params
    })
}

/**
 * 门店
 * 删除门店
 */
export const deleteShop = (id) => {
    return http({
        url: `/api/v1/showcase/shop/delete?id=${id}`,
        method: 'post'
    })
}

/**
 * 商品分类
 * 商品分类树
 */
export const queryGoodsClassifyTree = () => {
    return http({
        url: '/api/v1/tax/category/tree',
        method: 'get'
    })
}

/**
 * 商品分类
 * 创建商品分类
 */
export const createGoodsClassify = (params) => {
    return http({
        url: '/api/v1/tax/category/create',
        method: 'post',
        data: params
    })
}

/**
 * 商品分类
 * 商品分类编码校验
 */
export const goodsClassifyCheckCode = (params) => {
    return http({
        url: '/api/v1/tax/category/check',
        method: 'get',
        params: params
    })
}


/**
 * 商品分类
 * 查询商品分类详情
 */
export const queryGoodsClassifyDetails = (id) => {
    return http({
        url: `/api/v1/tax/category/detail?id=${id}`,
        method: 'get'
    })
}

/**
 * 商品分类
 * 修改商品分类
 */
export const updateGoodsClassify = (params) => {
    return http({
        url: '/api/v1/tax/category/update',
        method: 'post',
        data: params
    })
}

/**
 * 商品分类
 * 删除商品分类
 */
export const deleteGoodsClassify = (params) => {
    return http({
        url: '/api/v1/tax/category/delete',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 广告分类列表（分页）
 */
export const queryAdvertClassifyList = (params) => {
    return http({
        url: '/api/v1/showcase/category/page',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 广告分类列表（全部）
 */
export const searchAdvertClassifyList = (params) => {
    return http({
        url: '/api/v1/showcase/category/list',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 创建广告分类
 */
export const createAdvertClassify = (params) => {
    return http({
        url: '/api/v1/showcase/category/create',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 查询广告分类详情
 */
export const queryAdvertClassifyDetails = (id) => {
    return http({
        url: `/api/v1/showcase/category/detail?id=${id}`,
        method: 'get'
    })
}

/**
 * 广告
 * 修改广告分类
 */
export const updateAdvertClassify = (params) => {
    return http({
        url: '/api/v1/showcase/category/update',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 删除广告分类
 */
export const deleteAdvertClassify = (id) => {
    return http({
        url: `/api/v1/showcase/category/delete?id=${id}`,
        method: 'post'
    })
}

/**
 * 广告
 * 广告册列表（分页）
 */
export const queryAdvertBookList = (params) => {
    return http({
        url: '/api/v1/showcase/page',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 广告册列表（全部）
 */
export const searchAdvertBookList = (params) => {
    return http({
        url: '/api/v1/showcase/search',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 创建广告册
 */
export const createAdvertBook = (params) => {
    return http({
        url: '/api/v1/showcase/create',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 查询广告册详情
 */
export const queryAdvertBookDetails = (id) => {
    return http({
        url: `/api/v1/showcase/detail?id=${id}`,
        method: 'get'
    })
}

/**
 * 广告
 * 修改广告册
 */
export const updateAdvertBook = (params) => {
    return http({
        url: '/api/v1/showcase/update',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 删除广告册
 */
export const deleteAdvertBook = (id) => {
    return http({
        url: `/api/v1/showcase/delete?id=${id}`,
        method: 'post'
    })
}

/**
 * 广告
 * 启用广告册
 */
export const enableAdvertBook = (id) => {
    return http({
        url: `/api/v1/showcase/enable?id=${id}`,
        method: 'post'
    })
}

/**
 * 广告
 * 禁用广告册
 */
export const disenableAdvertBook = (id) => {
    return http({
        url: `/api/v1/showcase/disable?id=${id}`,
        method: 'post'
    })
}

/**
 * 广告
 * 查询广告册中的广告纸
 */
export const queryAdvertContainer = (params) => {
    return http({
        url: '/api/v1/showcase/item/list',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 更新广告册中的广告纸
 */
export const updateAdvertContainer = (params) => {
    return http({
        url: '/api/v1/showcase/item/update',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 查询广告纸列表
 */
export const queryAdvertPaperList = (params) => {
    return http({
        url: '/api/v1/showcase/item/page',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 更新广告纸裁剪是否完成
 */
export const updateAdvertPaperState = (id) => {
    return http({
        url: `/api/v1/showcase/item/finish?id=${id}`,
        method: 'post'
    })
}

/**
 * 广告
 * 查询广告切图列表
 */
export const queryAdvertCropperList = (params) => {
    return http({
        url: '/api/v1/exhibits/list',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 创建广告切图
 */
export const createAdvertCropper = (params) => {
    return http({
        url: '/api/v1/exhibits/create',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 上传广告文字切片
 */
export const uploadAdvertTextSlice = (params) => {
    return http({
        url: '/api/v1/file/extract/text',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 查询广告册详情
 */
export const queryAdvertCropperDetails = (id) => {
    return http({
        url: `/api/v1/exhibits/detail?id=${id}`,
        method: 'get'
    })
}

/**
 * 广告
 * 修改广告切图
 */
export const updateAdvertCropper = (params) => {
    return http({
        url: '/api/v1/exhibits/update',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 删除广告切图
 */
export const deleteAdvertCropper = (id) => {
    return http({
        url: `/api/v1/exhibits/delete?ids=${id}`,
        method: 'post',
    })
}

/**
 * 广告
 * 一键发布
 */
export const onkeyIssueAdvertBook = () => {
    return http({
        url: '/api/v1/showcase/one-click-enable',
        method: 'get',
    })
}

/**
 * 广告
 * 查询广告定时任务列表（分页）
 */
export const queryAdvertTimedTaskList = (params) => {
    return http({
        url: '/api/v1/showcase/schedule/page',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 广告定时任务编码校验
 */
export const advertTimedTaskCheckCode = (params) => {
    return http({
        url: '/api/v1/showcase/schedule/check',
        method: 'get',
        params: params
    })
}

/**
 * 广告
 * 创建广告定时任务
 */
export const createAdvertTimedTask = (params) => {
    return http({
        url: '/api/v1/showcase/schedule/create',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 查询广告定时任务详情
 */
export const queryAdvertTimedTaskDetails = (id) => {
    return http({
        url: `/api/v1/showcase/schedule/detail?id=${id}`,
        method: 'get'
    })
}

/**
 * 广告
 * 修改广告定时任务
 */
export const updateAdvertTimedTask = (params) => {
    return http({
        url: '/api/v1/showcase/schedule/update',
        method: 'post',
        data: params
    })
}

/**
 * 广告
 * 删除广告定时任务
 */
export const deleteAdvertTimedTask = (id) => {
    return http({
        url: `/api/v1/showcase/schedule/delete?id=${id}`,
        method: 'post'
    })
}

/**
 * 广告
 * 启用广告定时任务
 */
export const enableAdvertTimedTask = (id) => {
    return http({
        url: `/api/v1/showcase/schedule/enable?id=${id}`,
        method: 'post'
    })
}

/**
 * 广告
 * 禁用广告定时任务
 */
export const disenableAdvertTimedTask = (id) => {
    return http({
        url: `/api/v1/showcase/schedule/disable?id=${id}`,
        method: 'post'
    })
}

/**
 * 广告
 * 运行广告定时任务
 */
export const runAdvertTimedTask = (id) => {
    return http({
        url: `/api/v1/showcase/schedule/run?id=${id}`,
        method: 'post'
    })
}

/**
 * 抽奖
 * 奖品列表（分页）
 */
export const queryLotteryPrizeList = (params) => {
    return http({
        url: '/api/v1/award/depot/page',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 奖品列表（全部）
 */
export const searchLotteryPrizeList = (params) => {
    return http({
        url: '/api/v1/award/depot/list',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 创建奖品
 */
export const createLotteryPrize = (params) => {
    return http({
        url: '/api/v1/award/depot/create',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 查询奖品详情
 */
export const queryLotteryPrizeDetails = (id) => {
    return http({
        url: `/api/v1/award/depot/detail?id=${id}`,
        method: 'get'
    })
}

/**
 * 抽奖
 * 更新奖品
 */
export const updateLotteryPrize = (params) => {
    return http({
        url: '/api/v1/award/depot/update',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 删除奖品
 */
export const deleteLotteryPrize = (id) => {
    return http({
        url: `/api/v1/award/depot/delete?id=${id}`,
        method: 'post'
    })
}

/**
 * 抽奖
 * 抽奖活动列表（分页）
 */
export const queryLotteryActivityList = (params) => {
    return http({
        url: '/api/v1/activity/page',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 抽奖活动列表（全部）
 */
export const searchLotteryActivityList = (params) => {
    return http({
        url: '/api/v1/activity/list',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 搜索抽奖活动
 */
export const searchLotteryActivity = (params) => {
    return http({
        url: '/api/v1/activity/search',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 创建抽奖活动
 */
export const createLotteryActivity = (params) => {
    return http({
        url: '/api/v1/activity/create',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 查询抽奖活动详情
 */
export const queryLotteryActivityDetails = (id) => {
    return http({
        url: `/api/v1/activity/detail?id=${id}`,
        method: 'get'
    })
}

/**
 * 抽奖
 * 更新抽奖活动
 */
export const updateLotteryActivity = (params) => {
    return http({
        url: '/api/v1/activity/update',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 删除抽奖活动
 */
export const deleteLotteryActivity = (id) => {
    return http({
        url: `/api/v1/activity/delete?id=${id}`,
        method: 'post'
    })
}

/**
 * 抽奖
 * 更新抽奖活动
 */
export const lotteryLivePush = (params) => {
    return http({
        url: '/api/v1/activity/pushed',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 查询奖项（分页）
 */
export const queryLotteryAwardsList = (params) => {
    return http({
        url: '/api/v1/activity/awards/page',
        method: 'post',
        data: params
    })
}
/**
 * 抽奖
 * 查询奖项（全部）
 */
export const searchLotteryAwardsList = (params) => {
    return http({
        url: '/api/v1/activity/awards/list',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 生成奖项code
 */
export const generateLotteryAwardsCode = (params) => {
    return http({
        url: '/api/v1/lucky-award-code/create',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 创建奖项
 */
export const createLotteryAwards = (params) => {
    return http({
        url: '/api/v1/activity/awards/create',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 查询奖项详情
 */
export const queryLotteryAwardsDetails = (id) => {
    return http({
        url: `/api/v1/activity/awards/detail?id=${id}`,
        method: 'get'
    })
}

/**
 * 抽奖
 * 更新奖项
 */
export const updateLotteryAwards = (params) => {
    return http({
        url: '/api/v1/activity/awards/update',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 删除奖项
 */
export const deleteLotteryAwards = (id) => {
    return http({
        url: `/api/v1/activity/awards/delete?id=${id}`,
        method: 'post'
    })
}

/**
 * 抽奖
 * 删除奖项名额
 */
export const deleteLotteryAwardsQuota = (id) => {
    return http({
        url: `/api/v1/win-award-code/delete?id=${id}`,
        method: 'post'
    })
}

/**
 * 抽奖
 * 抽奖参与记录
 */
export const queryLotteryPartici = (params) => {
    return http({
        url: '/api/v1/lucky-award-code/page',
        method: 'post',
        data: params
    })
}

/**
 * 抽奖
 * 中奖记录
 */
export const queryLotteryWinning = (params) => {
    return http({
        url: '/api/v1/win/award/record/page',
        method: 'post',
        data: params
    })
}

/**
 * 反馈
 * 查询反馈列表
 */
export const queryFeedbackList = (params) => {
    return http({
        url: '/api/v1/feedback/list',
        method: 'post',
        data: params
    })
}

/**
 * 用户
 * 用户列表
 */
export const queryUserList = (params) => {
    return http({
        url: '/api/v1/user/page',
        method: 'post',
        data: params
    })
}

/**
 * 用户
 * 搜索用户列表
 */
export const searchUserList = (params) => {
    return http({
        url: '/api/v1/user/search',
        method: 'post',
        data: params
    })
}

/**
 * 用户
 * 用户启用
 */
export const userEnable = (params) => {
    return http({
        url: '/api/v1/user/enable',
        method: 'post',
        params: params
    })
}

/**
 * 用户
 * 用户禁用
 */
export const userDisable = (params) => {
    return http({
        url: '/api/v1/user/disable',
        method: 'post',
        params: params
    })
}
